import React, {useState} from "react";
import { useNavigate } from "react-router-dom";
import {sendSlackMessage, sendSlackMessageTracked} from "../../models/notifications";

const FooterComponent = () => {
  const navigate = useNavigate();

  const [emailAddress, setEmailAddress] = useState("");

  function handleSubscribe(event) {

    event.preventDefault();
    sendSlackMessageTracked(`🗞Lead is subscribing to the newsletter. Email: ${emailAddress} ----- 🗞️📰`)
    // TODO: Send email to backend - Add to CRM

    setTimeout(() => {
      // Load for a second
      alert("Successfully subscribed.");
    }, 1000);
  }

  const handleSectionClick = (section) => {
    const event = new CustomEvent("scrollToSection", {
      detail: { section },
    });
    window.dispatchEvent(event);
    navigate(`/?section=${section}`);
  };

  return (
    <section className="footer-section new">
      <div className="footer-wrapper new">
        <div className="footer-divider new" />
        <div className="footer-links-wrapper new">
          <div className="footer-links-column first">
            <div className="paragraph-20px footer-column-subheading">
              Product
            </div>
            <a href="/products/cashback" aria-current="page">
              <div className="paragraph-20px footer-link w-92">
                Cashback
              </div>
            </a>

            <a href="/products/memberships" aria-current="page">
              <div className="paragraph-20px footer-link w-92">
                Memberships
              </div>
            </a>

            {/*<a href="https://apps.shopify.com/pabloo-store-credit" aria-current="page">*/}
            {/*  <div className="paragraph-20px footer-link w-92">*/}
            {/*    Store Credit Refunds*/}
            {/*  </div>*/}
            {/*</a>*/}

            {/*<a href="/partners" aria-current="page">*/}
            {/*  <div className="paragraph-20px footer-link w-92">*/}
            {/*    Partnerships*/}
            {/*  </div>*/}
            {/*</a>*/}

            <a href="/store-credit-api" aria-current="page">
              <div className="paragraph-20px footer-link w-92">
                Store Credit API
              </div>
            </a>

            {/*<a href="https://apps.shopify.com/pabloo-store-credit" aria-current="page">*/}
            {/*  <div className="paragraph-20px footer-link w-92">*/}
            {/*    Store Credit API*/}
            {/*  </div>*/}
            {/*</a>*/}

          </div>

          <div
              id="w-node-_04f7ff85-bbba-0256-7cd8-9945cee9cc9d-cee9cc82"
              className="footer-links-column second"
          >
            <div className="paragraph-20px footer-column-subheading">
              Company
            </div>
            <a
              href="/partners"
              className="footer-link-wrapper w-inline-block cursor-pointer"
              // onClick={() => handleSectionClick("product")}
            >
              <div className="paragraph-20px footer-link">Partnerships</div>
            </a>
            <a href="/pricing" className="footer-link-wrapper w-inline-block">
              <div className="paragraph-20px footer-link">Pricing</div>
            </a>
            <a
              onClick={() => {
                window.open("/case-study");
              }}
              className="footer-link-wrapper w-inline-block cursor-pointer"
            >
              <div className="paragraph-20px footer-link">Resources</div>
            </a>
            <a
              onClick={() => handleSectionClick("testimonials")}
              className="footer-link-wrapper w-inline-block cursor-pointer"
            >
              <div className="paragraph-20px footer-link">Testimonials</div>
            </a>
            <a
                onClick={() => {
                  window.open("/features");
                }}
              className="footer-link-wrapper w-inline-block cursor-pointer"
            >
              <div className="paragraph-20px footer-link">Features</div>
            </a>
          </div>
          {Accounts()}
          {getInTouch()}
        </div>

        <div className="footer-bottom-wrapper">


          <div className="footer-divider new mt-12"/>
          <div className="footer-end-wrapper">
            <div className="privacy-links-contain w-full">
              <div className="w-full border-t border-gray-900/10 flex items-center justify-between">
                <div className="w-full">
                  <h4 className="text-sm/6 font-semibold text-gray-900">Subscribe to Pabloo's newsletter.</h4>
                  <p className="mt-2 text-sm text-gray-600 text-center md:text-left w-full">
                    Pabloo news, articles, and resources, sent to your inbox.
                  </p>
                </div>

                <div className="">
                  <form className="mt-6 sm:flex sm:max-w-md lg:mt-0" onSubmit={handleSubscribe}>
                    <label htmlFor="email-address" className="sr-only">
                      Email address
                    </label>
                    <input
                        id="email-address"
                        name="email-address"
                        type="email"
                        required
                        placeholder="Enter your email"
                        autoComplete="email"
                        value={emailAddress}
                        onChange={(e) => {
                          setEmailAddress(e.target.value)
                        }}
                        className="w-full min-w-0 rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:w-56 sm:text-sm/6"
                    />
                    <div className="mt-4 sm:mt-0 sm:ml-4 sm:shrink-0">
                      <button
                          type="submit"
                          className="flex w-full items-center justify-center rounded-md bg-black px-3 py-2.5 text-base font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                      >
                        Subscribe
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>


          <div className="footer-divider new mt-4"/>

          <div className="footer-end-wrapper">
            <div className="privacy-links-contain">
              <a
                  href="/solutions/cashback"
                  className="footer-link-wrapper w-inline-block"
              >
                <div className="paragraph-16px privacy-link">
                  How to use cashback
                </div>
              </a>
              <a
                  href="/solutions/memberships"
                  className="footer-link-wrapper w-inline-block"
              >
                <div className="paragraph-16px privacy-link">
                  How to use Membership tiers
                </div>
              </a>
            </div>
          </div>


          <div className="footer-divider new"/>
          <div className="footer-end-wrapper">
            <div className="privacy-links-contain">
              <a
                  href="/privacy-policy"
                  className="footer-link-wrapper w-inline-block"
              >
                <div className="paragraph-16px privacy-link">
                  Privacy Policy
                </div>
              </a>
              <a
                  href="/terms-and-conditions"
                  className="footer-link-wrapper w-inline-block"
              >
                <div className="paragraph-16px privacy-link">
                  Terms of service
                </div>
              </a>
            </div>
            <div className="paragraph-16px copyright-paragraph">
              Copyright © 2025 Pabloo, Inc. All rights reserved.
            </div>
            <div className="copyright-text-contain">
              <div
                  className="paragraph-16px copyright-paragraph"
                  style={{marginLeft: "25px"}}
              >
                588 King Street, San Francisco, CA 94158
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

function featuredIcons() {
  return (
      <div
          id="w-node-_04f7ff85-bbba-0256-7cd8-9945cee9ccd2-cee9cc82"
          className="footer-links-column fifth new"
      >
        <img
            src="https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/663c65d9f38a95f3c303ec91_Leader-Spring.svg"
            loading="lazy"
            alt=""
            className="badge-image new"
        />
        <img
            src="https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/663c65c55829aad6b0f4a2cf_Momentum-Leader.svg"
            loading="lazy"
            alt=""
            className="badge-image new"
        />
        <img
            src="https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/663c660681c0827a0f1ee262_Leader-Mid-Market.svg"
            loading="lazy"
            alt=""
            className="badge-image new"
        />
      </div>
  );
}


function getInTouch() {
  return (
      <div
          id="w-node-_04f7ff85-bbba-0256-7cd8-9945cee9ccbb-cee9cc82"
          className="footer-links-column fourth"
      >
        <div className="paragraph-20px footer-column-subheading" style={{width: '120%'}}>
        Get in touch
      </div>
      <a
        href="mailto:pabloo@pabloo.com?subject=Pabloo%20Email%20Support"
        className="footer-link-wrapper w-inline-block"
      >
        <div className="footer-link-icon w-embed">
          <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.0057 14.7011C13.4086 15.0992 12.7151 15.3096 12 15.3096C11.285 15.3096 10.5914 15.0992 9.99431 14.7011L0.159797 8.14459C0.105234 8.10822 0.0520781 8.0703 0 8.0313V18.7749C0 20.0067 0.999609 20.9843 2.20936 20.9843H21.7906C23.0224 20.9843 24 19.9847 24 18.7749V8.03125C23.9478 8.07034 23.8945 8.10836 23.8398 8.14478L14.0057 14.7011Z"
              fill="currentColor"
            />
            <path
              d="M0.939844 6.98088L10.7744 13.5375C11.1466 13.7857 11.5733 13.9098 12 13.9098C12.4267 13.9098 12.8534 13.7856 13.2256 13.5375L23.0602 6.98088C23.6487 6.58877 24 5.93252 24 5.22423C24 4.00638 23.0092 3.01562 21.7914 3.01562H2.20861C0.990797 3.01567 0 4.00642 0 5.22541C0 5.93252 0.351375 6.58877 0.939844 6.98088Z"
              fill="currentColor"
            />
          </svg>
        </div>
        <div className="paragraph-20px footer-link">Email</div>
      </a>
      <a
        href="https://www.linkedin.com/company/pabloo-inc/"
        target="_blank"
        className="footer-link-wrapper w-inline-block"
      >
        <div className="footer-link-icon w-embed">
          <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_714_1207)">
              <path
                d="M20.7273 0H3.27273C2.40475 0 1.57232 0.344804 0.95856 0.95856C0.344804 1.57232 0 2.40475 0 3.27273L0 20.7273C0 21.5953 0.344804 22.4277 0.95856 23.0414C1.57232 23.6552 2.40475 24 3.27273 24H20.7273C21.5953 24 22.4277 23.6552 23.0414 23.0414C23.6552 22.4277 24 21.5953 24 20.7273V3.27273C24 2.40475 23.6552 1.57232 23.0414 0.95856C22.4277 0.344804 21.5953 0 20.7273 0ZM8.18182 18.9927C8.182 19.0593 8.16904 19.1252 8.1437 19.1867C8.11836 19.2483 8.08112 19.3042 8.03412 19.3513C7.98713 19.3985 7.9313 19.4359 7.86983 19.4614C7.80836 19.4869 7.74246 19.5 7.67591 19.5H5.52C5.45333 19.5002 5.38729 19.4872 5.32566 19.4618C5.26404 19.4363 5.20804 19.399 5.1609 19.3518C5.11376 19.3047 5.0764 19.2487 5.05097 19.1871C5.02555 19.1254 5.01255 19.0594 5.01273 18.9927V9.95455C5.01273 9.82001 5.06617 9.69098 5.1613 9.59585C5.25644 9.50072 5.38546 9.44727 5.52 9.44727H7.67591C7.81021 9.44763 7.93889 9.50124 8.03372 9.59633C8.12856 9.69142 8.18182 9.82024 8.18182 9.95455V18.9927ZM6.59727 8.59091C6.19272 8.59091 5.79725 8.47095 5.46088 8.24619C5.12451 8.02143 4.86234 7.70197 4.70752 7.32822C4.5527 6.95446 4.5122 6.54319 4.59112 6.14641C4.67005 5.74963 4.86486 5.38516 5.15092 5.0991C5.43698 4.81304 5.80145 4.61823 6.19822 4.5393C6.595 4.46038 7.00628 4.50089 7.38003 4.6557C7.75379 4.81052 8.07325 5.07269 8.29801 5.40906C8.52276 5.74543 8.64273 6.1409 8.64273 6.54545C8.64273 7.08794 8.42723 7.60821 8.04363 7.99181C7.66003 8.37541 7.13976 8.59091 6.59727 8.59091ZM19.4509 19.0282C19.4511 19.0895 19.4391 19.1502 19.4158 19.2069C19.3924 19.2635 19.3581 19.315 19.3147 19.3584C19.2714 19.4017 19.2199 19.436 19.1632 19.4594C19.1066 19.4828 19.0458 19.4947 18.9845 19.4945H16.6664C16.6051 19.4947 16.5443 19.4828 16.4877 19.4594C16.431 19.436 16.3795 19.4017 16.3362 19.3584C16.2929 19.315 16.2585 19.2635 16.2351 19.2069C16.2118 19.1502 16.1998 19.0895 16.2 19.0282V14.7941C16.2 14.1614 16.3855 12.0232 14.5459 12.0232C13.1209 12.0232 12.8305 13.4864 12.7732 14.1436V19.0336C12.7732 19.1562 12.725 19.2738 12.639 19.361C12.553 19.4483 12.4361 19.4982 12.3136 19.5H10.0745C10.0134 19.5 9.95279 19.4879 9.89628 19.4645C9.83978 19.441 9.78846 19.4066 9.74526 19.3633C9.70206 19.32 9.66784 19.2686 9.64455 19.212C9.62126 19.1554 9.60937 19.0948 9.60955 19.0336V9.915C9.60937 9.85382 9.62126 9.79321 9.64455 9.73663C9.66784 9.68006 9.70206 9.62864 9.74526 9.58531C9.78846 9.54199 9.83978 9.50762 9.89628 9.48416C9.95279 9.46071 10.0134 9.44864 10.0745 9.44864H12.3136C12.4373 9.44864 12.5559 9.49777 12.6434 9.58523C12.7309 9.67269 12.78 9.79131 12.78 9.915V10.7032C13.3091 9.90818 14.0932 9.29727 15.7664 9.29727C19.4727 9.29727 19.4482 12.7582 19.4482 14.6591L19.4509 19.0282Z"
                fill="currentColor"
              />
            </g>
            <defs>
              <clipPath id="clip0_714_1207">
                <rect width={24} height={24} fill="currentColor" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div className="paragraph-20px footer-link">LinkedIn</div>
      </a>
      <a
        href="https://twitter.com/Pabloo_Co"
        target="_blank"
        className="footer-link-wrapper w-inline-block"
      >
        <div className="footer-link-icon w-embed">
          <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_714_1213)">
              <path
                d="M24 4.5585C23.1075 4.95 22.1565 5.2095 21.165 5.3355C22.185 4.7265 22.9635 3.7695 23.3295 2.616C22.3785 3.183 21.3285 3.5835 20.2095 3.807C19.3065 2.8455 18.0195 2.25 16.6155 2.25C13.8915 2.25 11.6985 4.461 11.6985 7.1715C11.6985 7.5615 11.7315 7.9365 11.8125 8.2935C7.722 8.094 4.1025 6.1335 1.671 3.147C1.2465 3.8835 0.9975 4.7265 0.9975 5.634C0.9975 7.338 1.875 8.8485 3.183 9.723C2.3925 9.708 1.617 9.4785 0.96 9.117C0.96 9.132 0.96 9.1515 0.96 9.171C0.96 11.562 2.6655 13.548 4.902 14.0055C4.5015 14.115 4.065 14.1675 3.612 14.1675C3.297 14.1675 2.979 14.1495 2.6805 14.0835C3.318 16.032 5.127 17.4645 7.278 17.511C5.604 18.8205 3.4785 19.6095 1.1775 19.6095C0.774 19.6095 0.387 19.5915 0 19.542C2.1795 20.9475 4.7625 21.75 7.548 21.75C16.602 21.75 21.552 14.25 21.552 7.749C21.552 7.5315 21.5445 7.3215 21.534 7.113C22.5105 6.42 23.331 5.5545 24 4.5585Z"
                fill="currentColor"
              />
            </g>
            <defs>
              <clipPath id="clip0_714_1213">
                <rect width={24} height={24} fill="currentColor" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div className="paragraph-20px footer-link">Twitter</div>
      </a>
      {/*  <a href="https://www.youtube.com/channel/UCjWfB7Jl1sWgMn4X6YGretw" target="_blank" className="footer-link-wrapper w-inline-block"><div className="footer-link-icon w-embed">*/}
      {/*  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
      {/*    <path d="M23.5055 6.50362C23.229 5.52463 22.4183 4.7529 21.3903 4.48929C19.5122 4 11.9997 4 11.9997 4C11.9997 4 4.48756 4 2.60948 4.47074C1.60122 4.73407 0.770802 5.52477 0.494239 6.50362C0 8.29172 0 12 0 12C0 12 0 15.727 0.494239 17.4964C0.771095 18.4752 1.58145 19.247 2.60962 19.5106C4.50733 20 12 20 12 20C12 20 19.5122 20 21.3903 19.5293C22.4185 19.2658 23.229 18.4941 23.5058 17.5152C23.9999 15.727 23.9999 12.0188 23.9999 12.0188C23.9999 12.0188 24.0197 8.29172 23.5055 6.50362ZM9.60793 15.4258V8.57416L15.8549 12L9.60793 15.4258Z" fill="currentColor" />*/}
      {/*  </svg>*/}
      {/*</div>*/}
      {/*  <div className="paragraph-20px footer-link">Youtube</div>*/}
      {/*</a>*/}
      {/*<a*/}
      {/*  href="https://www.instagram.com/pabloo_com"*/}
      {/*  target="_blank"*/}
      {/*  className="footer-link-wrapper w-inline-block"*/}
      {/*>*/}
      {/*  <div className="footer-link-icon w-embed">*/}
      {/*    <svg*/}
      {/*      width={24}*/}
      {/*      height={24}*/}
      {/*      viewBox="0 0 24 24"*/}
      {/*      fill="none"*/}
      {/*      xmlns="http://www.w3.org/2000/svg"*/}
      {/*    >*/}
      {/*      <g clipPath="url(#clip0_714_1223)">*/}
      {/*        <path*/}
      {/*          d="M18.9772 4.4375C18.656 4.4375 18.3945 4.69892 18.3945 5.02016C18.3945 5.34139 18.656 5.60281 18.9772 5.60281C19.2985 5.60281 19.5598 5.34144 19.5598 5.02016C19.5598 4.69888 19.2985 4.4375 18.9772 4.4375Z"*/}
      {/*          fill="currentColor"*/}
      {/*        />*/}
      {/*        <path*/}
      {/*          d="M11.9994 6.83594C9.1512 6.83594 6.83398 9.15316 6.83398 12.0014C6.83398 14.8496 9.1512 17.1669 11.9994 17.1669C14.8477 17.1669 17.1649 14.8496 17.1649 12.0014C17.1649 9.1532 14.8477 6.83594 11.9994 6.83594Z"*/}
      {/*          fill="currentColor"*/}
      {/*        />*/}
      {/*        <path*/}
      {/*          d="M17.4208 0H6.57923C2.95144 0 0 2.95144 0 6.57928V17.4208C0 21.0486 2.95144 24 6.57923 24H17.4208C21.0486 24 24 21.0486 24 17.4208V6.57928C24 2.95144 21.0486 0 17.4208 0ZM12 18.5828C8.37023 18.5828 5.4173 15.6298 5.4173 12C5.4173 8.37023 8.37028 5.41734 12 5.41734C15.6297 5.41734 18.5828 8.37028 18.5828 12C18.5828 15.6297 15.6297 18.5828 12 18.5828ZM18.9765 7.02356C17.8737 7.02356 16.9765 6.12637 16.9765 5.02359C16.9765 3.92081 17.8737 3.02358 18.9765 3.02358C20.0792 3.02358 20.9764 3.92077 20.9764 5.02355C20.9764 6.12633 20.0792 7.02356 18.9765 7.02356Z"*/}
      {/*          fill="currentColor"*/}
      {/*        />*/}
      {/*      </g>*/}
      {/*      <defs>*/}
      {/*        <clipPath id="clip0_714_1223">*/}
      {/*          <rect width={24} height={24} fill="currentColor" />*/}
      {/*        </clipPath>*/}
      {/*      </defs>*/}
      {/*    </svg>*/}
      {/*  </div>*/}
      {/*  <div className="paragraph-20px footer-link">Instagram</div>*/}
      {/*</a>*/}
    </div>
  );
}
function Accounts() {
  return (
    <section className="">
      <div className="">
        <div className="" />
        <div className="">
          <div
            id="w-node-_04f7ff85-bbba-0256-7cd8-9945cee9cc9d-cee9cc82"
            className="footer-links-column "
          >
            <div className="paragraph-20px footer-column-subheading">
              Account
            </div>
            <a href="/scheduleCall" className="footer-link-wrapper w-inline-block">
              <div className="paragraph-20px footer-link">Book a demo</div>
            </a>
            <a href="/signup" className="footer-link-wrapper w-inline-block">
              <div className="paragraph-20px footer-link">Create account</div>
            </a>
            {/*<a href="/login" className="footer-link-wrapper w-inline-block">*/}
            {/*  <div className="paragraph-20px footer-link">Login</div>*/}
            {/*</a>*/}
            <a href="https://app-extension.pabloo.com" className="footer-link-wrapper w-inline-block"
               onClick={() => {
                 sendSlackMessage(`Someone has clicked the login button in the footer.`, "#website-updates")
               }}
            >
              <div className="paragraph-20px footer-link">Login</div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FooterComponent;
